import React,{useEffect,useState} from "react";
import sliderInner from '../assets/images/sliderInner.jpg';
import leafIcn from '../assets/images/slider-shape-5.png';
import repairDev from '../assets/images/search-file_17864027.png';
import { useNavigate } from "react-router-dom";
import subThemes from "../helper/SubThemes_List";
import other from '../assets/images/other1.png';
import awarness from '../assets/images/awareness.png';
import bottle from '../assets/images/reuse_7583401.png';
import sayicon1 from"../assets/images/icon/homeIcons/theme7icon/icon-1.png";
import sayicon2 from"../assets/images/icon/homeIcons/theme7icon/icon-2.png";
import sayicon3 from"../assets/images/icon/homeIcons/theme7icon/icon-3.png";
import sayicon4 from"../assets/images/icon/homeIcons/theme7icon/icon-4.png";

function SaynoPlastic() {
  const navigate = useNavigate();
  const [themeData, setThemeData] = useState(null);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  scrollToTop()

  const handleRoute = (data) => {
    localStorage.setItem('sub_themes', subThemes['Say No to Single Use Plastic'][data].value);
    navigate('/details');
  };
  const fetchDetails = async (data) => {
    try {
      const response = await fetch(`https://ecoclubs.education.gov.in/api/get-participants-details?theme=Say No to Single Use Plastic`); // Replace with your API URL
      const result = await response.json();
      setThemeData(result?.data); // Store fetched data in state
    } catch (error) {
      console.error("Error fetching theme data:", error);
    }

    
  };

  useEffect(()=>{
    fetchDetails();
  },[])

  return (
    <>
      <section className="sliderSec sliderInnerSec">
        <img src={sliderInner} alt="" />
        <div className="sliderInrHdng">
        <h2>Eco Clubs <span className="hdngBrkr">for Mission LiFE Themes</span></h2>
         </div>
      </section>

      <section className="sevenScopeSec reduceWasteSec">
        <div className="container-fluid">
          <span className="contact__shape-1"></span>
          <h2>Say  No to<span className="hdngBrkr"> Single Use Plastic</span> </h2>
          <button className="button green btn-login-signup loginBtnnewhm" style={{position:"absolute", right:"6%"}} onClick={()=>navigate(-1)} >Back</button>       
          <div className="sevenScopeBox">
            <ul className="themeGrid">
              {[
                { label: "Plastic audit of school campus", icon: sayicon1 },
                { label: "Awareness campaigns", icon: sayicon2 },
                { label: "Replace plastic water bottles with steel", icon: sayicon3 },
                { label: "Others", icon: sayicon4 }
              ].map((theme, index) => (
                <li key={index} onClick={() => handleRoute(index)}>
                  <div className="themeBox orange7">
                    <div className="themeBoxIcn"><img src={theme.icon} alt="" /></div>
                    <div className="themeBoxCnt">{theme.label}</div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className='stackHolderSec'>
        <img className="slider__shape-13 stackholdrLf" src={leafIcn} alt="" />
        <div className="container-fluid">
          <span className="contact__shape-1"></span>
          {/* <h2><span className="hdngBrkr">Stakeholders</span> Involved</h2> */}
          <div className="stackHldrCntDiv">
  <div className="row">
    <div className="col-6 stackLft">
      <h2 className="sbHdng">participation AT A GLANCE</h2>
      <div className="stackLftIn">
        <ul>
          <li>
             States/UTs <span>{36}</span>
          </li>
          <li>
            Districts <span>{themeData ? themeData.districts : 0}</span>
          </li>
          <li>
            Total Schools <span>{themeData ? themeData.totalSchools : 0}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
        </div>
      </section>

    </>
  );
}

export default SaynoPlastic;
